import { render, staticRenderFns } from "./simultaneousInterpretationRecord.vue?vue&type=template&id=63fb466e&scoped=true"
import script from "./simultaneousInterpretationRecord.vue?vue&type=script&lang=js"
export * from "./simultaneousInterpretationRecord.vue?vue&type=script&lang=js"
import style0 from "./simultaneousInterpretationRecord.vue?vue&type=style&index=0&id=63fb466e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fb466e",
  null
  
)

export default component.exports